var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9h3v28h-3zM9.5 13h3v24h-3zM15.5 10h3v27h-3zM21.5 12h3v25h-3zM27.5 3h3v34h-3zM33.5 9h3v28h-3z"
  })));
}
export default SvgHighVolume;